<template>
    <div>

        <payment-method-modal v-if="showPaymentModal" @close="showPaymentModal = false" id="modalPaymentMethod" @jjPaymentMethodCreated="jjPaymentMethodCreated" ref="modalPaymentMethod" :locationId="locationId" isJj="true" isTpg="true" shouldCenter="1" style="z-index: 1000;" close-on-backdrop></payment-method-modal>

        <div class="form-save-message" role="alert" v-if="formSaved">
            <i class="fas fa-save"></i>
        </div>

        <div class="jj-signup">
            <!-- <Form  @submit="onSubmit" :validation-schema="schema" v-slot="{ errors }" class="form-check isJj" id="topOfForm"> -->
            <form method="post" enctype="multipart/form-data" @submit.prevent="onSubmit" class="form-check isJj" ref="topOfForm">

                <div class="alert alert-danger" v-if="errorString" v-html="errorString" id="signupErrors">
                </div>

                <div class="jj-signup-header">
                    Jimmy Tunes Activation Form

                    <div class="download-pdf">
                        <a href="/setup_guides/Jimmy_Tunes_Activation_Form.pdf" target="_NEW">Download Activation Form <i class="far fa-file-pdf"></i></a>
                    </div>
                </div>

                <div class="jj-signup-blurb">
                    The Playlist Generation is the official music service provider for Jimmy John’s. Each location specified on this form will be sent a link to download our Music Player that will run on your in-store Windows PC (not compatible with Macs). All links and
                    license keys will be sent to the Primary Contact on this form and will be sent within 3 business days.
                    <br>
                    <br>

                    <div>
                        <div class="player-update-radios">
                            <div class="form-check">
                                <input type="checkbox" class="isJj" name="is_ownership_transfer" id="is_ownership_transfer" v-model="is_ownership_transfer" value="true" @blur="handleBlur"> &nbsp;&nbsp; <span style="font-weight:bold;margin-top:-5px;cursor:pointer;"
                                    @click="ownershipTransferClicked()">For Ownership Transfer, click here</span>
                            </div>
                        </div>

                        <div class="row" v-if="is_ownership_transfer">
                            <input type="text" data-preownedstorenumbers v-model="preowned_store_numbers" ref="preowned_store_numbers" name="preowned_store_numbers" id="preowned_store_numbers" @blur="handleBlur">
                            <div style="font-size:11px;margin-top:5px;" :class="{inlineError:v$.preowned_store_numbers.$error}">Enter all store numbers to be transferred (e.g., 1234, 7890). We will apply the same Payment Method to the stores listed above. If you would like to enter a unique Payment Method for each store, please submit one entry per store
                                number.
                            </div>
                        </div>
                    </div>
                </div>
                <div class="jj-red all-required"><b>* All fields are required.</b></div>

                <br>
                <h4>General Information</h4>

                <div class="row">
                    <div class="form-left col-sm-6">
                        <div class="field-label" :class="{inlineError:v$.service_start_date.$error}">Service Start Date</div>
                        <div class="field-input">
                            <input type="text" v-model="service_start_date" ref="service_start_date" name="service_start_date" id="service_start_date" @blur="handleBlur" />
                        </div>
                    </div>

                    <div class="form-right col-sm-6">
                        <div class="field-label" :class="{inlineError:v$.primary_contact_name.$error}">Primary Contact Name</div>
                        <div class="field-input">
                            <input v-model="primary_contact_name" name="primary_contact_name" type="text" class="form-control" id="primary_contact_name" @blur="handleBlur" />
                        </div>

                    </div>
                </div>

                <div class="row">
                    <div class="form-left col-sm-6">
                        <div class="field-label" :class="{inlineError:v$.primary_contact_phone.$error}">Primary Contact Phone</div>
                        <div class="field-input">
                            <input type="text" v-model="primary_contact_phone" ref="primary_contact_phone" name="primary_contact_phone" id="primary_contact_phone" @blur="handleBlur" />
                        </div>
                    </div>
                    <div class="form-right col-sm-6">
                        <div class="field-label" :class="{inlineError:v$.primary_contact_email.$error}">Primary Contact Email</div>
                        <div class="field-input">
                            <input type="text" v-model="primary_contact_email" ref="primary_contact_email" name="primary_contact_email" id="primary_contact_email" @blur="handleBlur" />
                        </div>
                    </div>
                </div>

                <div v-if="!is_ownership_transfer">
                    <hr>
                    <h4>Store Information</h4>
                    <div class="row">
                        <div class="form-left col-sm-6">
                            <div class="field-label" :class="{inlineError:v$.store_number.$error}">Store Number</div>
                            <div class="field-input">
                                <input type="text" v-model="store_number" name="store_number" id="store_number" @blur="handleBlur" />
                            </div>
                        </div>
                        <div class="form-right col-sm-6">
                            <div class="field-label" :class="{inlineError:v$.store_phone.$error}">Store Phone</div>
                            <div class="field-input">
                                <input type="text" v-model="store_phone" name="store_phone" id="store_phone" @blur="handleBlur" />
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="form-left col-sm-6">
                            <div class="field-label" :class="{inlineError:v$.store_address.$error}">Store Address</div>
                            <div class="field-input">
                                <input type="text" v-model="store_address" name="store_address" id="store_address" @blur="handleBlur" />
                            </div>
                        </div>
                        <div class="form-right col-sm-6">
                            <div class="field-label" :class="{inlineError:v$.store_city.$error}">Store City</div>
                            <div class="field-input">
                                <input type="text" v-model="store_city" name="store_city" id="store_city" @blur="handleBlur" />
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="form-left col-sm-6">
                            <div class="field-label" :class="{inlineError:v$.store_state.$error}">Store State</div>
                            <div class="field-input">
                                <input type="text" v-model="store_state" name="store_state" id="store_state" @blur="handleBlur" />
                            </div>
                        </div>
                        <div class="form-right col-sm-6">
                            <div class="field-label" :class="{inlineError:v$.store_zip.$error}">Store Zip</div>
                            <div class="field-input">
                                <input type="text" v-model="store_zip" name="store_zip" id="store_zip" @blur="handleBlur" />
                            </div>
                        </div>
                    </div>
                </div>
                <hr>
                <div v-if="showMissingPaymentError && !one_time_token" class="alert alert-danger" id="missingPaymentError" ref="missingPaymentError">
                    Payment method is required
                </div>
                <h4>Payment Method</h4>

                <div v-if="one_time_token">
                    <div class="alert alert-success" role="alert">
                        Payment Method has been saved
                    </div>
                </div>
                <div v-else>
                    <div @click="showPaymentModal = true" class="add-payment-button">
                        Securely add payment method
                        <font-awesome-icon icon="lock" aria-hidden="false" />
                    </div>
                </div>

                <hr>
                <h4>Billing Information</h4>

                <div class="billing-same" @click="billingSameChecked()">
                    <div class="" style="width:10%;float:left">
                        <input type="checkbox" name="billing_same_as_store" id="billing_same_as_store" class="checkbox" v-model="billing_same_as_store" @blur="handleBlur" />
                    </div>
                    <div class="" style="width:90%;float:right">Click here if the Billing info is the same as store information</div>
                </div>

                <div v-if="!billing_same_as_store">
                    <div class="row">
                        <div class="form-left col-sm-6">
                            <div class="field-label" :class="{inlineError:v$.billing_address.$error}">Billing Address</div>
                            <div class="field-input">
                                <input type="text" v-model="billing_address" name="billing_address" id="billing_address" :disabled="billing_same_as_store" @blur="handleBlur" />
                            </div>
                        </div>
                        <div class="form-right col-sm-6">
                            <div class="field-label" :class="{inlineError:v$.billing_city.$error}">Billing City</div>
                            <div class="field-input">
                                <input type="text" v-model="billing_city" name="billing_city" id="billing_city" :disabled="billing_same_as_store" @blur="handleBlur" />
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="form-left col-sm-6">
                            <div class="field-label" :class="{inlineError:v$.billing_state.$error}">Billing State</div>
                            <div class="field-input">
                                <input type="text" v-model="billing_state" name="billing_state" id="billing_state" :disabled="billing_same_as_store" @blur="handleBlur" />
                            </div>
                        </div>
                        <div class="form-right col-sm-6">
                            <div class="field-label" :class="{inlineError:v$.billing_zip.$error}">Billing Zip</div>
                            <div class="field-input">
                                <input type="text" v-model="billing_zip" name="billing_zip" id="billing_zip" :disabled="billing_same_as_store" @blur="handleBlur" />
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="form-left col-sm-6">
                            <div class="field-label" :class="{inlineError:v$.billing_contact_name.$error}">Billing Contact Name</div>
                            <div class="field-input">
                                <input type="text" v-model="billing_contact_name" name="billing_contact_name" id="billing_contact_name" :disabled="billing_same_as_store" @blur="handleBlur" />
                            </div>
                        </div>
                        <div class="form-right col-sm-6">
                            <div class="field-label" :class="{inlineError:v$.billing_contact_phone.$error}">Billing Contact Phone</div>
                            <div class="field-input">
                                <input type="text" v-model="billing_contact_phone" name="billing_contact_phone" id="billing_contact_phone" :disabled="billing_same_as_store" @blur="handleBlur" />
                            </div>
                        </div>
                    </div>

                    <div class="row">
                        <div class="col-sm-12">
                            <div class="field-label" :class="{inlineError:v$.billing_contact_email.$error}">Billing Contact Email</div>
                            <div class="field-input">
                                <input type="text" v-model="billing_contact_email" name="billing_contact_email" id="billing_contact_email" :disabled="billing_same_as_store" @blur="handleBlur" />
                            </div>
                        </div>
                    </div>

                </div>
                <hr>
                <h4>Sign and Date</h4>

                <div class="row">
                    <div class="form-left col-sm-6">
                        <div class="field-label" :class="{inlineError:v$.signature.$error}">Signature</div>
                        <div class="field-input">
                            <input type="text" v-model="signature" name="signature" id="signature" @blur="handleBlur" />
                            <div style="clear:left;height:12px;color:#666;width:100%;padding-left:3px;font-family: 'Indie Flower', cursive !important;">{{signature}}</div>
                        </div>
                    </div>
                    <div class="form-right col-sm-6">
                        <div class="field-label" :class="{inlineError:v$.date.$error}">Date</div>
                        <div class="field-input">
                            <input type="text" v-model="date" name="date" id="date" @blur="handleBlur" />
                        </div>
                    </div>
                </div>

                <button class="sign-in-button jj-signup-button" :disabled="formHasBeenSubmitted">
                            SUBMIT ACTIVATION FORM
                        </button>
                <br><br><br><br><br><br><br>
            </form>

        </div>
    </div>
</template>

<script>
import useVuelidate from '@vuelidate/core';
import { required, requiredIf, helpers } from '@vuelidate/validators';
import PaymentMethodModal from '../../../shared/PaymentMethodModal.vue';

const Querystring = require('querystring');

export default {
  setup() {
    return { v$: useVuelidate() };
  },
  components: {
    PaymentMethodModal,
  },
  data() {
    return {
      locationId: 'JIMMYJOHNS',
      errorString: '',
      formSaved: false,
      messageTimer: '',
      is_ownership_transfer: false,
      preowned_store_numbers: '',
      service_start_date: '',
      store_number: '',
      store_address: '',
      store_city: '',
      store_state: '',
      store_zip: '',
      store_phone: '',
      primary_contact_name: '',
      primary_contact_phone: '',
      primary_contact_email: '',
      billing_same_as_store: false,
      billing_address: '',
      billing_city: '',
      billing_zip: '',
      billing_state: '',
      billing_contact_name: '',
      billing_contact_email: '',
      billing_contact_phone: '',
      signature: '',
      date: '',
      one_time_token: '',
      payment_type: '',
      payment_name: '',
      showMissingPaymentError: false,
      formHasBeenSubmitted: false,
      showPaymentModal: false,
    };
  },
  validations() {
    return {
      preowned_store_numbers: {
        required: helpers.withMessage('Store number(s) required', requiredIf(function () {
          return this.is_ownership_transfer;
        })),
      },
      store_number: {
        required: helpers.withMessage('Store number is required', requiredIf(function () {
          return !this.is_ownership_transfer;
        })),
      },
      store_zip: {
        required: helpers.withMessage('Store zip is required', requiredIf(function () {
          return !this.is_ownership_transfer;
        })),
      },
      store_state: {
        required: helpers.withMessage('Store state is required', requiredIf(function () {
          return !this.is_ownership_transfer;
        })),
      },
      store_city: {
        required: helpers.withMessage('Store city is required', requiredIf(function () {
          return !this.is_ownership_transfer;
        })),
      },
      store_phone: {
        required: helpers.withMessage('Store phone is required', requiredIf(function () {
          return !this.is_ownership_transfer;
        })),
      },
      store_address: {
        required: helpers.withMessage('Store address is required', requiredIf(function () {
          return !this.is_ownership_transfer;
        })),
      },
      service_start_date: { required: helpers.withMessage('Service start date is required', required) },
      primary_contact_name: { required: helpers.withMessage('Primary contact name is required', required) },
      primary_contact_phone: { required: helpers.withMessage('Primary contact phone is required', required) },
      primary_contact_email: { required: helpers.withMessage('Primary contact email is required', required) },
      billing_address: {
        required: helpers.withMessage('Billing address is required', requiredIf(function () {
          return !this.billing_same_as_store;
        })),
      },
      billing_city: {
        required: helpers.withMessage('Billing city is required', requiredIf(function () {
          return !this.billing_same_as_store;
        })),
      },
      billing_state: {
        required: helpers.withMessage('Billing state is required', requiredIf(function () {
          return !this.billing_same_as_store;
        })),
      },
      billing_zip: {
        required: helpers.withMessage('Billing zip is required', requiredIf(function () {
          return !this.billing_same_as_store;
        })),
      },
      billing_contact_name: {
        required: helpers.withMessage('Billing contact name is required', requiredIf(function () {
          return !this.billing_same_as_store;
        })),
      },
      billing_contact_email: {
        required: helpers.withMessage('Billing contact email is required', requiredIf(function () {
          return !this.billing_same_as_store;
        })),
      },
      billing_contact_phone: {
        required: helpers.withMessage('Billing contact phone is required', requiredIf(function () {
          return !this.billing_same_as_store;
        })),
      },
      signature: { required: helpers.withMessage('Signature is required', required) },
      date: { required: helpers.withMessage('Date is required', required) },
    };
  },
  mounted() {},
  methods: {
    onSubmit() {
      this.formHasBeenSubmitted = true;
      this.v$.$validate();
      this.errorString = '';
      if (!this.v$.$error) {
        // Check if payment method has been submitted
        this.showMissingPaymentError = false;
        if (!this.one_time_token) {
          this.formHasBeenSubmitted = false;
          this.showMissingPaymentError = true;
          return;
        }

        const postJSON = this.createJSON(true);
        this.postData(postJSON);
      } else {
        this.formHasBeenSubmitted = false;

        const errors = this.v$.$errors;
        let errorList = '<b>Errors</b></b><ul>';
        for (let i = 0; i < errors.length; i++) {
          errorList += `<li>${errors[i].$message}</li>`;
        }

        errorList += '</ul>';
        const validationErrorList = errorList;
        this.$wkToast(validationErrorList);

        this.$nextTick(() => {
          const el = this.$refs.topOfForm;
          if (el) {
            el.scrollIntoView({ behavior: 'smooth' });
          }
        });
      }

      // this.$validator.validateAll().then(res => {
      //     if (res) {
      // //Check if payment method has been submitted
      // this.showMissingPaymentError = false;
      // if (!this.one_time_token) {
      //     this.showMissingPaymentError = true;
      //     return;
      // }

      //     } else {
      //         this.formHasBeenSubmitted = false;
      //         var errorBag = this.errors.all();
      //         try {
      //             this.$toasted.show(this.returnValidatorErrors(errorBag), TOAST_ERROR);
      //         } catch (error) {console.log()}
      //     }
      // })
    },
    billingSameChecked() {
      this.billing_same_as_store = !this.billing_same_as_store;
    },
    ownershipTransferClicked() {
      this.is_ownership_transfer = !this.is_ownership_transfer;
    },
    jjPaymentMethodCreated(data) {
      if (data) {
        this.one_time_token = data.one_time_token;
        this.payment_type = data.type;
        this.payment_name = data.name;
      }
    },
    handleBlur() {
      // Disable per Jarrett June21, 2021
      // let postJSON = this.createJSON();
      // this.postData(postJSON);
    },
    createJSON(isSubmitted) {
      const data = {
        is_ownership_transfer: this.is_ownership_transfer,
        service_start_date: this.service_start_date,
        store_number: this.store_number,
        store_address: this.store_address,
        store_city: this.store_city,
        store_state: this.store_state,
        store_zip: this.store_zip,
        store_phone: this.store_phone,
        primary_contact_name: this.primary_contact_name,
        primary_contact_phone: this.primary_contact_phone,
        primary_contact_email: this.primary_contact_email,
        signature: this.signature,
        date: this.date,
        one_time_token: this.one_time_token,
        payment_type: this.payment_type,
        payment_name: this.payment_name,
      };

      if (this.is_ownership_transfer) {
        data.preowned_store_numbers = this.preowned_store_numbers;
      }

      if (this.billing_same_as_store) {
        data.billing_address = this.store_address;
        data.billing_city = this.store_city;
        data.billing_zip = this.store_zip;
        data.billing_state = this.store_state;
        data.billing_contact_name = this.primary_contact_name;
        data.billing_contact_email = this.primary_contact_email;
        data.billing_contact_phone = this.primary_contact_phone;
      } else {
        data.billing_address = this.billing_address;
        data.billing_city = this.billing_city;
        data.billing_zip = this.billing_zip;
        data.billing_state = this.billing_state;
        data.billing_contact_name = this.billing_contact_name;
        data.billing_contact_email = this.billing_contact_email;
        data.billing_contact_phone = this.billing_contact_phone;
      }

      if (isSubmitted) {
        data.submitted = true;
      }

      return data;
    },
    postData(data) {
      if (!data) return;

      const self = this;
      this.$http.post('/onboarding/jimmyjohns', Querystring.stringify(data)).then((response) => {
        self.handlePostSuccess(response, data);
      },
      (response) => {
        self.handlePostFailure(response);
      }).catch((response) => {
        self.handlePostFailure(response);
      });
    },
    handlePostSuccess(response, data) {
      clearInterval(this.messageTimer);
      this.formSaved = true;

      // If the form was successfully submitted and not autosaved, forward to route
      if (data.submitted) {
        this.$router.push({ path: '/signup_success' });
      } else {
        this.messageTimer = setInterval(this.removeFormSavedMessage, 3000);
      }
    },
    handlePostFailure(response) {
      this.errorString = response;
    },
    removeFormSavedMessage() {
      this.formSaved = false;
      clearInterval(this.messageTimer);
    },
  },
  computed: {

  },
  watch: {
    billing_same_as_store() {
      this.handleBlur();
    },
    one_time_token() {
      this.handleBlur();
    },
    showMissingPaymentError() {
      if (this.showMissingPaymentError) {
        this.$nextTick(() => {
          const el = this.$refs.missingPaymentError;
          if (el) {
            el.scrollIntoView({ behavior: 'smooth' });
          }
        });
      }
    },
  },
};
</script>

<style scoped>
.field-label {
    font-size: 14px;
}

.field-label {
    font-size: 14px;
}

.jj-red,
.inlineError {
    color: rgb(224, 0, 43);
}

a,
a:hover,
a:visited {
    color: black;
}

h4 {
    text-align: center;
    margin-top: 50px;
}

hr {
    color: rgb(94, 94, 94);
}

.jj-signup {
    color: rgb(37, 37, 37);
    font-size: 14px;
}

.jj-signup-header {
    width: 100%;
    margin: 0 auto;
    text-align: center;
    color: #666;
    font-size: 20px;
    clear: both;
    padding-bottom: 30px;
    margin-top: 60px;
}

.jj-signup input[type="checkbox"] {
    width: 14px;
    height: 14px;
    border: 1px solid rgb(75, 75, 75);
}

.jj-signup input[type="text"] {
    border: 1px solid #ccc;
    background: #fff;
    color: #666;
    border-radius: 5px;
    width: 100%;
    height: 36px;
    font-weight: normal;
    padding: 5px;
}

.textarea-holder {
    width: 100%;
    text-align: center;
}

.jj-signup-button {
    margin-top: 50px;
}

.jj-signup-blurb {
    border-bottom: 1px solid rgb(75, 75, 75);
    padding: 10px;
    margin-bottom: 20px;
}

.form-save-message {
    position: fixed;
    z-index: 2;
    bottom: 15px;
    left: 5px;
    height: 20px;
    line-height: 20px;
    width: 20px;
    padding: 2px;
    text-align: center;
    background: transparent;
    font-size: 24px;
    color: #fff;
    opacity: .6;
}

.jj-signup input[type="text"]:disabled {
    background: #efefef;
}

.row {
    margin-top: 5px;
}

.billing-same {
    width: 96%;
    margin: 0 auto;
    border: 1px solid #ccc;
    background: #efefef;
    min-height: 40px;
    height: auto;
    padding: 5px;
    line-height: 30px;
    cursor: pointer;
    border-radius: 3px;
    margin-bottom: 10px;
}

.ownership-transfer {
    width: 100%;
    background: #fff;
    padding: 0px;
    height: auto;
    line-height: auto;
    cursor: pointer;
    border-radius: 3px;
    margin-bottom: 10px;
}

.add-payment-button {
    max-width: 280px;
    margin: 0 auto;
    text-align: center;
    background: rgb(192, 44, 44);
    color: white;
    height: auto;
    position: relative;
    display: block;
    height: 40px;
    line-height: 30px;
    padding: 5px;
    cursor: pointer;
}

.add-payment-button:hover {
    opacity: .85;
}

.payment-saved {
    width: 100%;
    text-align: center;
    background: rgb(23, 143, 29);
    color: white;
}

.download-pdf {
    position: absolute;
    right: 12px;
    top: 77px;
    text-align: right;
    font-size: 12px;
}

.form-check {
    height: auto;
}

.all-required {
    width: 100%;
    text-align: right;
    clear: both;
    margin-top: -17px;
}

#billing_same_as_store.checkbox {
    font-weight: bold;
    margin-top: 7px;
}

@media (max-width: 850px) {
    .all-required {
        text-align: left;
        padding-left: 10px;
        padding-top: 5px;
    }
    .billing-same {
        width: 96%;
        margin: 0 auto;
        min-height: 50px;
        line-height: 18px;
    }
    #billing_same_as_store.checkbox {
        font-weight: bold;
        margin-top: 13px;
    }
    .download-pdf {
        width: 100%;
        clear: both;
        text-align: center;
        position: relative;
        right: auto;
        top: auto;
    }
}

</style>
